import { ADMIN_HOST } from "./hosts";

function resolveApiBase() {
  if (typeof window === "undefined") return "https://careers.mtn.co.rw";
  const host = String(window.location.hostname || "").toLowerCase();
  if (host === ADMIN_HOST || host === "localhost" || host === "127.0.0.1" || /^10\.150\.\d{1,3}\.\d{1,3}$/.test(host)) {
    return window.location.origin;
  }
  return "https://careers.mtn.co.rw";
}

export const API_BASE_URL = resolveApiBase();